<div :class="['sidebar', { open: isSidebarOpen }]">
    <div :class="['toggler', { rotate: isSidebarOpen }]" @click="toggleSidebar">
        <font-awesome-icon :icon="['fas', 'bars']" />
    </div>
    <ul class="sidebar-menu">
        <li class="menu-item" v-for="item in menuItems" :key="item.text">
            <router-link :to="item.path">
                <font-awesome-icon :icon="item.icon" />
                <span class="menu-text">{{ item.text }}</span>
            </router-link>
        </li>
        <li class="menu-item">
            <button class="logout" @click="onLogOut">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                <span class="menu-text">LogOut</span>
            </button>
        </li>
    </ul>
</div>